import React from "react";
import Hero from "@/components/home/Hero";
import BrandsGrid from "@/components/home/BrandsGrid";
import RecentPayouts from "@/components/home/RecentPayouts";
import Calculator from "@/components/home/Calculator";
import HowItWorks from "@/components/home/HowItWorks";
import TrustSection from "@/components/home/TrustSection";
import Testimonials from "@/components/home/Testimonials";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Calculator />
      <BrandsGrid />
      <RecentPayouts />
      <HowItWorks />
      <TrustSection />
      <Testimonials />

      <section className="py-24 bg-gradient-to-br from-[#F8FAFC] to-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B3C5D] tracking-tight">
            Ready to turn unused gift cards into cash?
          </h2>
          <p className="mt-4 text-slate-600 max-w-xl mx-auto">
            Transparent rates, secure submissions, and clear status tracking from submission to
            payout.
          </p>
          <Link
            to="/sell"
            className="mt-8 inline-flex items-center justify-center rounded-full bg-[#0B3C5D] text-white px-8 py-4 text-base font-semibold btn-primary"
            data-testid="home-bottom-cta"
          >
            Start Selling <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
